import type { RouteSectionProps } from "@solidjs/router";
import { ThreadScreen } from "@core/domains/threads/screens/ThreadScreen";

const ThreadPage = (props: RouteSectionProps<unknown>) => {
  return <ThreadScreen {...props} />;
};

export default ThreadPage;
